import React, { useState, useCallback, useEffect } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDumbbell, faChartLine, faBullseye, faMap, faBrain, faEye, faChartBar,faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileUpload from './components/FileUpload';
import ColumnSelection from './components/ColumnSelection';
import AnimatedEllipsis from './components/AnimatedEllipsis';
import VisualizationPanel from './components/VisualizationPanel';
import './styles/App.css'; 

library.add(faDumbbell, faChartLine, faBullseye, faMap, faBrain, faEye, faChartBar,faTag);

const getAllColumns = (obj) => {
  let columns = [];
  if (Array.isArray(obj)) {
    return obj;
  }
  if (typeof obj === 'object') {
    for (let key in obj) {
      columns = columns.concat(getAllColumns(obj[key]));
    }
  }
  return columns;
};

export default function App() {
  const [file, setFile] = useState(null);
  const [filePath, setFilePath] = useState(null);
  const [outputOption, setOutputOption] = useState({ option: 'detailed', showDetailedDescriptions: true });
  const [columns, setColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [error, setError] = useState(null);
  const [activePanel, setActivePanel] = useState(0);
 
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isFetchingColumns, setIsFetchingColumns] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0); // State to store progress percentage
  const [progressMessage, setProgressMessage] = useState(''); // State to 
  const [processingStatus, setProcessingStatus] = useState('');
  // const [showDetailedDescriptions, setShowDetailedDescriptions] = useState(false);
  const [isServerReachable, setIsServerReachable] = useState(true); // To track if server is reachable
  const [errorMessage, setErrorMessage] = useState(null); // State to store the error message
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]); // state to store the original column order
  const [jobId, setJobId] = useState(null); // Add jobId to state
  const [uploadJobId, setUploadJobId] = useState(null);
  const [columnsJobId, setColumnsJobId] = useState(null);

  // Function to check if the server is reachable

// //  // Initialize Socket.IO client
// //  useEffect(() => {
// //   const socket = io(''); // Connect to your Socket.IO server

// //   socket.on('progress', (data) => {
// //     if (data.progress !== undefined) {
// //       setProgress(data.progress); // Update progress percentage
// //     }
// //     if (data.status) {
// //       setProgressMessage(data.status); // Update progress message
// //     }
// //   });

//   // Clean up the socket connection when the component unmounts
//   return () => {
//     socket.off('progress');
//   };
// }, []);

useEffect(() => {
  let pollInterval;

  const checkProgress = async () => {
    if (columnsJobId) {  // Only check progress if we have a jobId
      try {
        const response = await fetch(`/api/progress?job_id=${columnsJobId}`);
        const data = await response.json();
        
        if (data.status === 'error') {
          setProgressMessage(data.message);
          setProcessingStatus('error');
          clearInterval(pollInterval);
          return;
        }

        setProgress(data.progress);
        setProgressMessage(data.message);
        setProcessingStatus(data.status);

        // Stop polling if process is complete or errored
        if (data.status === 'completed' || data.status === 'error') {
          clearInterval(pollInterval);
        }
      } catch (error) {
        console.error('Error checking progress:', error);
        setProgressMessage('Error checking progress');
        setProcessingStatus('error');
        clearInterval(pollInterval);
      }
    }
  };
// Start polling when we have a jobId
if (columnsJobId) {
  checkProgress(); // Check immediately
  pollInterval = setInterval(checkProgress, 1000); // Then check every second
}

// Cleanup function
return () => {
  if (pollInterval) {
    clearInterval(pollInterval);
  }
};
}, [columnsJobId]); // Depend on jobId



  const checkServerReachability = async () => {
    try {
      // Try fetching a simple URL from your server
      const response = await fetch('https://space.fhtsecethz.org/ping', { method: 'GET', mode: 'no-cors' });
      
      // If response is not OK, the server might be blocked
      if (!response.ok) {
        throw new Error('Network issue or server is blocked');
      }

      setIsServerReachable(true); // Server is reachable
    } catch (error) {
      // If fetch fails, it indicates that the server is unreachable, possibly due to Wi-Fi network restrictions
      setIsServerReachable(false);
      setErrorMessage('Please try with your 4G internet'); // Set the custom error message
    }
  };

  const buttons = [
    'Overview', 'Training', 'Path Integration', 'Egocentric Pointing', 'Mapping', 'Memory', 'Perspective Taking'
  ];
  const handleHelperClick = () => {
    window.open('https://github.com/nana0211/SPACEDATAVIZTUTORIAL?tab=readme-ov-file#website-usage-guide', '_blank');
  };


  useEffect(() => {
    // Check if the server is reachable when the component loads
    checkServerReachability();
  }, []);

  useEffect(() => {
    if (columns && Object.keys(columns).length > 0) {
      const allColumns = getAllColumns(columns);
      console.log("All columns in useEffect:", allColumns);
      setSelectedColumns(allColumns);
      setOriginalColumnOrder(allColumns); // Save the original order here
    }
  }, [columns]);

  const handleFileSelect = (selectedFile) => {
    setFile(selectedFile);
    setError(null);
    setIsFileUploaded(false);
    setColumns([]);
  };
  
  
  // Function to handle file upload and initiate columns processing
  const handleUploadAndFetchColumns = async () => {
    if (!file) {
      setError('Please select a file before uploading.');
      return;
    }
    // Check if the file is neither JSON nor ZIP
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (fileExtension !== 'json' && fileExtension !== 'zip') {
      setError('Please upload a JSON or ZIP file. Other formats are not supported.');
      return;
    }
    setError(null);
    setIsFileUploaded(false);
    setIsExpanded(false);
    setIsUploading(true);
    setIsFetchingColumns(false);
    try {
      console.log("Starting file upload...");
      const formData = new FormData();
      formData.append('file', file);
      // Upload the file and get a job ID
      const uploadResponse = await fetch('/api/upload', {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });
      if (!uploadResponse.ok) {
        throw new Error(`HTTP error! status: ${uploadResponse.status}`);
      }
      const uploadData = await uploadResponse.json();
      if (!uploadData.success) {
        throw new Error(uploadData.message || 'Unknown error occurred during file upload. Please check if the file format is correct.');
      }
      console.log("File uploaded successfully. Response:", uploadData);
      const jobId = uploadData.job_id;
      setUploadJobId(uploadData.job_id);
      // Get the job ID from the response
       // Check if job_id is present in the response
      if (!jobId) {
        console.error("Error: job_id is missing in upload response.");
        throw new Error("Failed to retrieve job ID from server.");
      }

      console.log("File uploaded successfully. Job ID:", jobId);
      const uploadedFilePath = uploadData.file_path;
      setFilePath(uploadedFilePath);

      // Start columns processing
      await fetchColumns(uploadedFilePath,jobId);

      setIsUploading(false);
      setIsFetchingColumns(true); // Already set in fetchColumns, but kept here for clarity
      setIsFileUploaded(true);
    } catch (e) {
      console.error('Error during upload or fetching columns:', e);
      setError(e.message || 'Failed to upload file or fetch columns. Please try again.');
      setIsUploading(false);
      setIsFetchingColumns(false);
    }
  };

  // fetchColumns function, now accepts jobId directly
const fetchColumns = useCallback(async (resultFilePath, jobId) => {  // Accept jobId as an argument
  setError(null);
  setIsFetchingColumns(true);
  setIsUploading(false);

  const pollTaskStatus = (statusUrl, jobId, onSuccess, onFailure) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await fetch(`${statusUrl}?job_id=${jobId}`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        const data = await response.json();
        console.log('Task status:', data);

        if (data.status === 'completed') {
          clearInterval(intervalId);
          onSuccess(data);
        } else if (data.status === 'failed') {
          clearInterval(intervalId);
          onFailure(data.error || 'Task failed. Please try again.');
        } else {
          if (data.progress !== undefined) {
            setProgress(data.progress);
          }
          if (data.status_message) {
            setProgressMessage(data.status_message);
          }
        }
      } catch (e) {
        console.error('Error polling task status:', e);
        clearInterval(intervalId);
        onFailure(`Failed to check task status: ${e.message}`);
      }
    }, 5000);
  };

  const pollColumnsStatus = (jobId) => {  // pollColumnsStatus uses jobId passed from upload
    const onSuccess = (data) => {
      let newColumns = {};
      if (data && Array.isArray(data.columns)) {
        newColumns = data.columns.reduce((acc, { key, value }) => {
          acc[key] = value;
          return acc;
        }, {});
      } else {
        setError("Unexpected data format received from server");
        setIsFetchingColumns(false);
        return;
      }
      setColumns(newColumns);
      console.log("Columns set in state:", newColumns);
      const allColumns = getAllColumns(newColumns);
      setSelectedColumns(allColumns);
      console.log("All columns selected by default:", allColumns);
      setIsFetchingColumns(false);
    };

    const onFailure = (errorMessage) => {
      setError(errorMessage);
      setIsFetchingColumns(false);
    };

    pollTaskStatus('/api/columns_status', jobId, onSuccess, onFailure);
  };

  try {
    console.log(`Starting columns processing for result file: ${resultFilePath}`);
    const response = await fetch(`/api/columns?option=${outputOption.option}&file_path=${encodeURIComponent(resultFilePath)}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const data = await response.json();
    console.log("Columns processing started. Response:", data);

    // Use the jobId from the upload to poll for the status
    pollColumnsStatus(data.job_id);  // Directly use jobId passed in
    setColumnsJobId(data.job_id);

  } catch (e) {
    console.error('Error starting columns processing:', e);
    setError(`Failed to start columns processing: ${e.message}`);
    setIsFetchingColumns(false);
  }
}, [outputOption]);

  const handleSetSelectedColumns = (newSelectedColumns) => {
    console.log("Updating selected columns in App:", newSelectedColumns);
  
   // Ensure columns are reordered according to the original order
    const reorderedColumns = originalColumnOrder.filter(col => newSelectedColumns.includes(col));
    console.log("Updating reordered columns in App:", reorderedColumns);
    setSelectedColumns(reorderedColumns);
  };

  const handleDownload = async () => {
    setError(null);
    setIsDownloading(true);
    try {
      const requestData = { 
        columns: selectedColumns, 
        option: outputOption.option,
        file_path: filePath,
        job_id: columnsJobId
      };
      console.log('Sending download request with:', JSON.stringify(requestData, null, 2));
      const response = await fetch('/api/process', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
        credentials: 'include'
      });
      console.log('Response status:', response.status);
      console.log('Response headers:', JSON.stringify(Object.fromEntries(response.headers), null, 2));
 
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Server response:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // Get the original filename from the server response or use the uploaded filename
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = file ? `${file.name.split('.')[0]}_results.csv` : 'output_results.csv';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Error processing data:', e);
      setError(`Failed to process data: ${e.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className={`app-container ${isExpanded ? 'expanded' : ''}`} style={{
      display: 'flex', 
      height: '100vh',
    }}>
       {/* If the server is not reachable, display the error message */}
    {!isServerReachable && (
      <div style={{ color: 'red', fontSize: '18px', fontWeight: 'bold', marginBottom: '20px' }}>
        {errorMessage}
      </div>
    )}
      {/* Left Panel */}
      <div className="left-panel" style={{
        position: 'fixed', // Fix the left panel
        height: '100vh',
        width: isExpanded ? '30%' : '45%',
        backgroundColor: '#f97316', 
        color: 'white', 
        padding: '48px', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <div>
          <h1 style={{fontSize: '3rem', fontWeight: 'bold', marginBottom: '48px'}}>SPACE Data Parser</h1>
          <FileUpload onFileSelect={handleFileSelect} file={file} />

          <div style={{marginTop: '48px'}}>
            <h3 style={{fontSize: '1.5rem', marginBottom: '24px'}}>Select Output Option:</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
              <label style={{display: 'flex', alignItems: 'center', gap: '12px', fontSize: '1.125rem'}}>
                <input
                  type="radio"
                  value="detailed"
                  checked={outputOption.option === 'detailed'}
                  onChange={() => setOutputOption({ option: 'detailed', showDetailedDescriptions: true })}
                  style={{width: '20px', height: '20px'}}
                />
                <span>Detailed Measures</span>
              </label>
              <label style={{display: 'flex', alignItems: 'center', gap: '12px', fontSize: '1.125rem'}}>
                <input
                  type="radio"
                  value="summary"
                  checked={outputOption.option === 'summary'}
                  onChange={() => setOutputOption({ option: 'summary', showDetailedDescriptions: false })}
                  style={{width: '20px', height: '20px'}}
                />
                <span>Quick Summary of Measures</span>
              </label>
            </div>
          </div>

          {activePanel === 0 && (
            <button 
              onClick={handleUploadAndFetchColumns}
              style={{
                marginTop: '24px',
                backgroundColor: 'white',
                color: '#f97316',
                padding: '12px 24px',
                borderRadius: '4px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#fb923c';
                e.target.style.color = 'white';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#f97316';
              }}
            >
              Upload your file
            </button>
          )}

          <div style={{fontSize: '0.875rem', marginTop: '48px'}}>
            © 2024 SPACE Data Parser. All rights reserved.
          </div>
        </div>
        {/* Helper Icon */}
        <div style={{
          position: 'fixed',
           // Position the icon in the top-left corner
          top: '16px',
          left: '16px',
        }}>
          <FontAwesomeIcon 
            icon="tag" 
            size="2x" 
            style={{ cursor: 'pointer', color: 'white' }} 
            onClick={handleHelperClick} 
          />
        </div>
        {/* Dot buttons below the left panel removed */}
      </div>

      {/* Right Panel */}
      <div style={{
        marginLeft: isExpanded ? '30%' : '50%', // Adjust the right panel to account for the fixed left panel
        width: isExpanded ? '70%' : '50%', 
        backgroundColor: 'white', 
        padding: '48px', 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}>
        {activePanel === 0 ? (
          <>
            <h2 style={{fontSize: '3rem', fontWeight: 'bold', marginBottom: '32px', color: '#1f2937'}}>Select Columns for Download</h2>
            <div style={{ width: '100%' }}>
              {isUploading && <p style={{fontSize: '1.25rem', color: '#4b5563'}}>Uploading your file<AnimatedEllipsis /></p>}
              {isFetchingColumns && <p style={{fontSize: '1.25rem', color: '#4b5563'}}>Fetching columns<AnimatedEllipsis /></p>}
              {isDownloading && <p style={{fontSize: '1.25rem', color: '#4b5563'}}>File downloading, wait a few seconds<AnimatedEllipsis />.</p>}
              {error && (
                <div style={{fontSize: '1.25rem', color: 'red', marginBottom: '20px'}}>
                  <p>Error: {error}</p>
                  <p>Please try uploading the file again or contact support: nana.tian@sec.ethz.ch if the problem persists.</p>
                </div>
              )}
              {!isUploading && !isFetchingColumns && !isDownloading && !error && (
                isFileUploaded ? (
                  console.log("Columns in render:", columns),
                  Object.keys(columns).length > 0 ? (
                    <ColumnSelection
                      columns={columns}
                      selectedColumns={selectedColumns}
                      setSelectedColumns={handleSetSelectedColumns}
                      onDownload={handleDownload}
                      showDetailedDescriptions={outputOption.showDetailedDescriptions}
                    />
                  ) : (
                    <p style={{fontSize: '1.25rem', color: '#4b5563'}}>No columns found in the uploaded file.</p>
                  )
                ) : (
                  <p style={{fontSize: '1.25rem', color: '#4b5563'}}>
                    {file ? 'Click "Upload your file" to process and view columns' : 'Please select a file to upload'}
                  </p>
                )
              )} 
              {/* Progress Section */}
              {(isUploading || isFetchingColumns || isDownloading) && (
                <div style={{ width: '100%', marginTop: '24px' }}>
                  
                  <div className="progress-bar" style={{
                    width: '100%',
                    height: '8px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '4px',
                    overflow: 'hidden'
                  }}>
                    <div 
                      className="progress-fill" 
                      style={{
                        width: `${progress}%`,
                        height: '100%',
                        backgroundColor: '#f97316',
                        transition: 'width 0.3s ease-in-out'
                      }}
                    />
                  </div>
                  <div style={{
                    marginTop: '8px',
                    fontSize: '0.875rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: '#4b5563'
                  }}>
                    <span>{progressMessage}</span>
                    <span>{Math.round(progress)}%</span>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <VisualizationPanel buttons={buttons} />
        )}
      </div>
    </div>
  );
}